<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('placeOrder.BatchExport')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="500px"
    @close="clearForm"
  >
    <el-form
      ref="exportOrderFormRef"
      :model="exporOrderForm"
      class="demo-exporOrderForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="numberType"
      >
        <el-select v-model="exporOrderForm.numberType" style="width: 60%">
          <!--运单号-->
          <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
          <!--扫描单号-->
          <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="numberSet"
        style="width: 100%"
      >
        <el-input
          v-model="exporOrderForm.numberSet"
          :placeholder="$t('mdfeTranslate.multipleLineInput')"
          clearable
          rows="6"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 15px 0">
      <el-button
        size="small" @click="dialogVisibleExport = false"
      >{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button
        size="small" type="primary" @click="comfireExport"
      >{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { lmLossResponsibilityBatchExport } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      dialogVisibleExport: false,
      exporOrderForm: {
        numberType: 1,
        numberSet: ''
      }
    };
  },
  methods: {
    handleOpen() {
      this.dialogVisibleExport = true;
    },
    clearForm() {
      this.exporOrderForm.numberType = 1;
      this.exporOrderForm.numberSet = '';
    },
    comfireExport() {
      this.$refs['exportOrderFormRef'].validate((valid) => {
        if (valid) {
          const numberList = this.exporOrderForm.numberSet
            ? this.exporOrderForm.numberSet.split('\n')
            : [];
          let numList = numberList.filter((item) => item !== '');
          if (numList && numList.length > 100000) {
            numList = numList.slice(0, 100000);
            this.$message.warning(this.$t('mdfeTranslate.queryLimitNotice'));
          }
          const param = {
            numberType: this.exporOrderForm.numberType,
            numberSet: numList
          };
          lmLossResponsibilityBatchExport(param).then(() => {
            this.dialogVisibleExport = false;
            goResourceTaskList();
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
